export default __webpack_public_path__ + "static/media/Lato-Thin.b1956ff2.woff2";